<template lang="html">
  <div>

    <section class="idioma">
      <button @click="langselected = 'ca'" :active="lang == 'ca'">CA</button>
      <button @click="langselected = 'es'" :active="lang == 'es'">ES</button>
      
    </section>

    <div class="cover-popup row-center" v-if="langselected">
      <div class="popup">
        <p>{{$t('popup_idioma.titulo')}}</p>
        <div class="contenedor-botones row-center">
          <button @click="requestLangChange" class="btn -solid-primary">{{$t('registro.si')}}</button>
          <button @click="langselected = ''" class="btn -skull-primary">{{$t('registro.no')}}</button>
        </div>
      </div>
    </div>
    
  </div>
</template>

<script lang="js">

  import { mapGetters, mapActions } from 'vuex';

  export default {
    name: 'idioma',
    data: () => ({
      show: true,
      langselected : ''
    }),
    methods: {
      ...mapActions(['changeLanguage', 'requestAllData']),
      requestLangChange() {
        this.changeLanguage(this.langselected).then(() => {
          this.langselected = '';
          this.requestAllData();
        });
      },
    },
    computed: {
      ...mapGetters({
        lang: 'getLanguage',
        style : 'getStyles'
      })
    }
  }
</script>

<style scoped lang="scss">
  .idioma {
    margin-left: 10px;
    display: flex;
    position: relative;

    span {
      text-transform: uppercase;
      height: 25px;
      line-height: 25px;
      cursor: pointer;
      width: 100%;
      background: red;
      display: inline-block;
      text-align: left;
    }

    > button {
      background: transparent;
      padding:0 10px;
      border:none;
      text-transform: uppercase;
      font-size: 18px;
      border-right: 1px solid white;
      cursor: pointer;
      &[active=true]{
        font-weight: bold;
      }
      &:last-child{
        border:none;
      }
    }
  }

  .popup{
      min-height: 150px;
    }

    .popup p{
      width: 100%;
      text-align: left;
      font-weight: bold;
      color:black;
    }

</style>


// WEBPACK FOOTER //
// submodules/dotia-base-fp/src/components/parts/idioma.vue